export default __webpack_public_path__ + "static/media/wb.251c8c5b.png";